import React from "react";
import { motion } from "framer-motion";
import companyLogo from "../../assets/images/logo/light-logo-half.png";
import TypingText from "../utils/TypingText";
import bgImage from "../../assets/images/hero-image-20.jpg"; // <-- Background image

const socials = [
  {
    id: 1,
    logo: "https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png",
    name: "Instagram",
    description:
      "Follow behind-the-scenes, expeditions, updates and exclusive moments.",
    button: "Follow us",
    link: "https://www.instagram.com/bb.adventures_",
  },
  {
    id: 2,
    logo: "https://framerusercontent.com/images/lTRuCxkmxeIKqNbj2JiXUFWgdw.png",
    name: "YouTube",
    description:
      "Tips, documentaries, and in-depth expedition videos to inspire the community",
    button: "Subscribe",
    link: "https://www.youtube.com/@TheBroadBoy",
  },
];

export default function HeroSection() {
  return (
<section
  className="relative bg-[#0e1b26] text-white px-6 md:px-20 pt-32 pb-20 text-center overflow-hidden"
>

  {/* Background Mountain Image (blurred) */}
  <div
    className="absolute inset-0 bg-cover bg-center opacity-30"
    style={{
      backgroundImage: `url('/assets/images/backgrounds/mountain-dark.jpg')`,
      filter: "blur(6px)",
    }}
  />

  {/* Top + Bottom Gradient Fade */}
  <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black/70"></div>

  {/* Subtle radial spotlight behind logo */}
  <div className="absolute top-1/2 left-1/2 w-[900px] h-[900px] -translate-x-1/2 -translate-y-1/2 bg-white/5 rounded-full blur-3xl"></div>

   {/* Watermark Text */}
    <h1
      className="
        absolute left-1/2 -translate-x-1/2
        font-black text-white/10 tracking-tight leading-none
        pointer-events-none select-none
      "
      style={{
        fontSize: "clamp(3rem, 16vw, 15rem)",
        top: "clamp(2.5rem, 2.1vw, 2.5rem)",
      }}
    >
      BROADBOY
    </h1>


    <h1
      className="
        absolute left-1/2 -translate-x-1/2
        font-black text-white/10 tracking-tight leading-none
        pointer-events-none select-none
      "
      style={{
        fontSize: "clamp(0.6rem, 13vw, 13rem)",
        top: "calc(clamp(3rem, 2.1vw, 2.5rem) + 0.9em)"

      }}
    >
      ADVENTURES
    </h1>




  {/* MAIN CONTENT */}
  <motion.img
    src={companyLogo}
    className="relative z-20 w-36 md:w-56 mx-auto"
    initial={{ scale: 0, rotate: -180, opacity: 0 }}
    whileInView={{ scale: 1, rotate: 0, opacity: 1 }}
    transition={{ duration: 1.2 }}
  />

  <div className="relative z-20 max-w-4xl mx-auto space-y-6 mt-10">
    <p className="font-light px-3 py-11 text-[#d0d0d0] text-[20px] leading-relaxed">
      <TypingText
        speed={0.01}
        text="
          Join us where courage meets altitude.
          Where dreams climb higher than the clouds.
          Let’s conquer peaks and rewrite what’s possible together.

          At BroadBoy Adventures, every expedition is a story of belief, resilience, and discovery.
          We elevate climbers to push beyond limits and experience what only a few dare to chase.

          Adventure isn’t just where we go  it’s who we become.
          Stand above the clouds. Live the stories people will tell for years.

          BroadBoy Adventures 
          Where legends rise, one summit at a time.
        "
      />
    </p>
  </div>

  {/* SOCIAL CARDS */}
  {/* <div className="relative z-20 grid grid-cols-1 md:grid-cols-2 gap-10 mt-10 max-w-5xl mx-auto">
    {socials.map((item) => (
      <div
        key={item.id}
        className="bg-white/10 backdrop-blur-lg rounded-3xl shadow-xl p-8 
        text-center md:text-left"
      >
        <img src={item.logo} className="w-20 h-20 rounded-2xl mb-6 mx-auto md:mx-0" />
        <h5 className="text-2xl font-semibold">{item.name}</h5>
        <p className="text-gray-300 mt-2">{item.description}</p>

        <a
          href={item.link}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-6 inline-block px-6 py-3 rounded-full border border-white/50 
          hover:bg-white hover:text-black transition mx-auto md:mx-0"
        >
          {item.button}
        </a>
      </div>
    ))}
  </div> */}

</section>

  );
}
